export default {
  "monitor.tasks.status.canceled": "Canceled",
  "component.globalHeader.search": "Search",
  "component.globalHeader.search.example1": "Search example 1",
  "component.globalHeader.search.example2": "Search example 2",
  "component.globalHeader.search.example3": "Search example 3",
  "component.globalHeader.help": "Help",
  "component.globalHeader.notification": "Notification",
  "component.globalHeader.notification.empty":
    "You have viewed all notifications.",
  "component.globalHeader.message": "Message",
  "component.globalHeader.message.empty": "You have viewed all messsages.",
  "component.globalHeader.event": "Event",
  "component.globalHeader.event.empty": "You have viewed all events.",
  "component.noticeIcon.clear": "Clear",
  "component.noticeIcon.cleared": "Cleared",
  "component.noticeIcon.empty": "No notifications",
  "component.noticeIcon.view-more": "View more",

  // ===== LLMMonitor =====
  "monitor.llm.popoverTitle": "LLM In-Flight Tasks",
  "monitor.llm.leaseSuffix": "lease {seconds}s",
  "monitor.llm.limiterDisabled": "Rate limiter disabled",
  "monitor.llm.degraded": "Redis connection error, monitor degraded: {error}",
  "monitor.llm.unknown": "Unknown",
  "monitor.llm.emptyRunning": "No LLM calls in flight",
  "monitor.llm.emptyDisabled": "LLM rate limiter disabled",
  "monitor.llm.queueTitle": "Queued · {count}",
  "monitor.llm.queueHint": "Waiting for slot",
  "monitor.llm.waitedPrefix": "wait {elapsed}",
  "monitor.llm.triggerTitle": "LLM in-flight {count}/{max}",
  "monitor.llm.triggerTitleWithQueue":
    "LLM in-flight {count}/{max} · queued {waiting}",
  "monitor.llm.triggerTitleDisabled": "LLM rate limiter disabled (max=0)",

  // LLM caller labels
  "monitor.llm.caller.parse-detect-marker": "Project - Marker Detection",
  "monitor.llm.caller.parse-infer-meta": "Project - Infer Metadata",
  "monitor.llm.caller.extract-characters": "Extract Characters",
  "monitor.llm.caller.extract-scenes": "Extract Scenes",
  "monitor.llm.caller.gen-character-prompts": "Character Prompts",
  "monitor.llm.caller.storyboard-gen": "Storyboard Gen",
  "monitor.llm.caller.storyboard-shot-regenerate": "Shot Regenerate",
  "monitor.llm.caller.video-prompt": "Video Prompt",

  // ===== BusinessTaskMonitor =====
  "monitor.tasks.popoverTitle": "My Tasks",
  "monitor.tasks.headerSummary": "{processing} in flight · {completed} done",
  "monitor.tasks.empty": "No tasks yet",
  "monitor.tasks.emptyHint":
    "Long-running actions like extract / storyboard / generate appear here",
  "monitor.tasks.degraded":
    "Backend connection error, monitor degraded: {error}",
  "monitor.tasks.viewAll": "View My Requests",
  "monitor.tasks.sectionInFlight": "In Flight",
  "monitor.tasks.sectionRecent": "Recently Completed",
  "monitor.tasks.recentHint": "last 24h",
  "monitor.tasks.elapsedSuffix": "{elapsed} elapsed",
  "monitor.tasks.elapsedTotal": "took {elapsed}",
  "monitor.tasks.triggerTitle":
    "My tasks · {processing} in flight · {completed} done",
  "monitor.tasks.triggerTitleEmpty": "My Tasks",
  "monitor.tasks.openDetail": "View requests",
  "monitor.tasks.cancel": "Cancel",
  "monitor.tasks.cancelConfirm": "Cancel task?",
  "monitor.tasks.cancelConfirmDesc": "You can start it again later.",
  "monitor.tasks.cancelConfirmOk": "Cancel task",
  "monitor.tasks.cancelConfirmCancel": "Keep running",
  "monitor.tasks.cancelOk": "{affected} sub-task(s) cancelled",
  "monitor.tasks.cancelNoop": "Task is no longer in flight",
  "monitor.tasks.cancelFailed": "Cancel failed: {error}",

  "monitor.tasks.status.queued": "Queued",
  "monitor.tasks.waitTimedOut": "Taking longer; still checking",
  "monitor.tasks.status.processing": "In flight",
  "monitor.tasks.status.completed": "Completed",
  "monitor.tasks.status.partial": "Partial",
  "monitor.tasks.status.failed": "Failed",

  "monitor.tasks.kind.parse-project": "Parse Project",
  "monitor.tasks.kind.adapt-novel": "Adapt Novel",
  "monitor.tasks.kind.extract-characters": "Extract Characters",
  "monitor.tasks.kind.extract-scenes": "Extract Scenes",
  "monitor.tasks.kind.gen-canonical": "Character Portrait",
  "monitor.tasks.kind.gen-character-prompts": "Generate Character Prompts",
  "monitor.tasks.kind.batch-generate": "Batch Image Gen",
  "monitor.tasks.kind.gen-sheet": "Character Sheet",
  "monitor.tasks.kind.gen-scene-sheet": "Scene 4-View Sheet",
  "monitor.tasks.kind.gen-storyboard": "Generate Storyboard",
  "monitor.tasks.kind.gen-shot-frames": "Shot Frames",
  "monitor.tasks.kind.gen-video-prompts": "Video Prompts",
  "monitor.tasks.kind.canvas-image": "Canvas Image",
  "monitor.tasks.kind.canvas-video": "Canvas Video",
  "monitor.tasks.kind.canvas-audio": "Canvas Audio",
  "monitor.tasks.kind.reverse-prompt-image": "Reverse Prompt (Image)",
  "monitor.tasks.kind.reverse-prompt-video": "Reverse Prompt (Video)",
  "monitor.tasks.kind.gen-scene-canonical": "Scene Canonical",
  "monitor.tasks.kind.gen-scene-sheet-kind": "Scene Multi-View Sheet",
  "monitor.tasks.kind.gen-scene-extra-view": "Scene Extra View",
  "monitor.tasks.kind.gen-shot-audio": "Shot Audio",

  // canvas-image sub-kinds (BusinessTask.sub_kind driven)
  "monitor.tasks.subkind.canvas_image_freegen": "Canvas Image",
  "monitor.tasks.subkind.canvas_image_matting": "Cutout",
  "monitor.tasks.subkind.canvas_image_relight": "Relight",
  "monitor.tasks.subkind.canvas_image_multi_view": "Multi-View",
  "monitor.tasks.subkind.canvas_image_inpaint": "Inpaint",
  "monitor.tasks.subkind.canvas_image_outpaint": "Outpaint",
  "monitor.tasks.subkind.canvas_image_hd": "HD",

  "monitor.tasks.modal.title": "My Requests",
  "monitor.tasks.modal.refresh": "Refresh",
  "monitor.tasks.modal.filterAll": "All",
  "monitor.tasks.modal.colKind": "Kind",
  "monitor.tasks.modal.colTarget": "Target",
  "monitor.tasks.modal.colStatus": "Status",
  "monitor.tasks.modal.colProgress": "Progress",
  "monitor.tasks.modal.colCost": "Credits",
  "monitor.tasks.modal.colTime": "Time",
  "monitor.tasks.modal.colRequests": "Requests",
  "monitor.tasks.modal.colActions": "Actions",
  "monitor.tasks.modal.expand": "Expand",
  "monitor.tasks.modal.collapse": "Collapse",
  "monitor.tasks.modal.requestColLabel": "Sub-request",
  "monitor.tasks.modal.requestColStatus": "Status",
  "monitor.tasks.modal.requestColCreated": "Started",
  "monitor.tasks.modal.requestColElapsed": "Elapsed",
  "monitor.tasks.modal.requestColCost": "Credits",
  "monitor.tasks.modal.requestColError": "Error",
  "monitor.tasks.modal.noRequests": "No sub-requests for this task",
  "monitor.tasks.modal.detailFailed": "Failed to load requests: {error}",

  // ===== Footer =====
  "app.footer.copyright": "Powered by Genvas",
};
